import {useEntitlement} from '@github-ui/copilot-entitlement/EntitlementContext'
import {useChatQuotaBannerResult} from '@github-ui/copilot-shared-ui/hooks/use-entitlement-quota-notice'
import type {
  QuotaBannerVariant as SharedQuotaBannerVariant,
  UseQuotaBannerResult as SharedUseQuotaBannerResult,
} from '@github-ui/copilot-shared-ui/utils/chat-quota-notice-state'

export type QuotaBannerVariant = SharedQuotaBannerVariant
export type UseQuotaBannerResult = SharedUseQuotaBannerResult

export function useQuotaBanner() {
  return useChatQuotaBannerResult(useEntitlement())
}
